import {environment} from '../../../environments/environment';
import {JwtHelper} from 'angular2-jwt';
import {TokenContext} from '../../models/user/token-context';
import {UserLoginModel} from '../../models/user/user-login.model';
import {UserModel} from '../../models/user/users.model';
import {Toast, ToasterService} from 'angular5-toaster/dist';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/toPromise';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ErrorObservable} from 'rxjs/observable/ErrorObservable';
import {Subject} from 'rxjs/Subject';
import {Role} from '../../enums/role.enum';
import {Observable} from 'rxjs/Observable';
import { SurveyService } from '../../routes/surveys/surveys.service';

const AUTH_KEY = 'BA-Token';
const USER_KEY = 'User';

@Injectable()
export class AuthTokenService {

  public token: string;
  private loginURL = environment.apiUrl + '/User/Login';
  private authenticationState = new Subject<any>();

  static getToken() {
    if (sessionStorage.getItem(AUTH_KEY) === null) {
      return localStorage.getItem(AUTH_KEY);
    } else {
      return sessionStorage.getItem(AUTH_KEY);
    }
  }

  static hasToken() {
    return AuthTokenService.getToken() !== null;
  }

  static getParsedToken(): string {
    if (sessionStorage.getItem(AUTH_KEY) !== null) {
      return JSON.parse(sessionStorage.getItem(AUTH_KEY)).token;
    } else if (localStorage.getItem(AUTH_KEY) !== null) {
      return JSON.parse(localStorage.getItem(AUTH_KEY)).token;
    }
  }

  static setUser(user: UserModel) {
    user.role = user.role.toLowerCase();
    if (sessionStorage.getItem(USER_KEY) === null) {
      localStorage.removeItem(USER_KEY);
      localStorage.setItem(USER_KEY, JSON.stringify({user: user}));
    } else {
      sessionStorage.removeItem(USER_KEY);
      sessionStorage.setItem(USER_KEY, JSON.stringify({user: user}));
    }
  }

  static getUser(): UserModel {
    if (sessionStorage.getItem(USER_KEY) === null) {
      const object = JSON.parse(localStorage.getItem(USER_KEY));

      if (!object) {
        const user = new UserModel();
        user.id = 0;
        return user;
      }
      return object.user;
    } else {
      const object = JSON.parse(sessionStorage.getItem(USER_KEY));
      if (!object) {
        const user = new UserModel();
        user.id = 0;
        return user;
      }
      return object.user;
    }
  }

  static isShowWordCloud(): boolean {
    return false;
  }

  static isAdmin(): boolean {
    if (sessionStorage.getItem(USER_KEY) != null) {
      const object = JSON.parse(sessionStorage.getItem(USER_KEY));
      return object.user.role === Role.ADMIN;
    } else {
      return false;
    }
  }

  static isUser(): boolean {
    if (sessionStorage.getItem(USER_KEY) != null) {
      const object = JSON.parse(sessionStorage.getItem(USER_KEY));
      return object.user.role === Role.USER;
    } else {
      return false;
    }
  }

  static isCustomerUser(): boolean {
    if (sessionStorage.getItem(USER_KEY) != null) {
      const object = JSON.parse(sessionStorage.getItem(USER_KEY));
      return object.user.role === Role.CUSTOMER_USER;
    } else {
      return false;
    }
  }

  static isCustomerAdmin(): boolean {
    if (sessionStorage.getItem(USER_KEY) != null) {
      const object = JSON.parse(sessionStorage.getItem(USER_KEY));
      return object.user.role === Role.CUSTOMER_ADMIN;
    } else {
      return false;
    }
  }

  public static decodeJwtToken(): TokenContext {
    let tokenContext: TokenContext = new TokenContext();
    const jwtHelper: JwtHelper = new JwtHelper();

    const token: string = AuthTokenService.getParsedToken();
    if (token) {
      tokenContext = jwtHelper.decodeToken(token);
      return tokenContext;
    } else {
      return null;
    }
  }

  constructor(private http: HttpClient,
              private toasterService: ToasterService,
              private surveyService: SurveyService) {
  }

  hasAnyAuthority(authorities: string[]): boolean {
    if (!AuthTokenService.hasToken()) {
      return false;
    }

    const user = AuthTokenService.getUser();
    if (!user || !user.role) {
      return false;
    }
    return authorities.includes(user.role);
  }

  getAuthenticationState(): Observable<any> {
    return this.authenticationState.asObservable();
  }

  private handleError(error: HttpErrorResponse | any) {
    let errMsg: string;
    if (error.error instanceof ErrorEvent) {
      errMsg = error.error.message;
    } else {
      errMsg = error.error.message ? error.error.message : error.toString();
    }

    const toast: Toast = {
      type: 'error',
      title: 'Error',
      body: errMsg,
      showCloseButton: true,
      timeout: 5000
    };

    this.toasterService.pop(toast);
    this.token = null;
    this.authenticationState.next(this.token);
    return new ErrorObservable({status: error.status, message: errMsg});
  }

  login(userModel: UserLoginModel, rememberMe: boolean) {

    return this.http.post(this.loginURL, userModel)
      .map((response: any) => {
          const token = response.token;
          const user = response.user;

          if (token) {
            this.token = token;

            if (rememberMe) {
              localStorage.setItem(AUTH_KEY, JSON.stringify({token: token}));
              localStorage.setItem(USER_KEY, JSON.stringify({user: user}));
            } else {
              sessionStorage.setItem(AUTH_KEY, JSON.stringify({token: token}));
              sessionStorage.setItem(USER_KEY, JSON.stringify({user: user}));
            }
            this.authenticationState.next(this.token);
            return response;
          } else {
            this.token = null;
            this.authenticationState.next(this.token);
            return false;
          }
        },
        _ => {
        }
      )
      .catch((response) => this.handleError(response));

  }

  isAuthenticated() {
    return new Promise(
      (resolve, _) => {
        resolve(AuthTokenService.getToken());
      }
    );
  }

  logout() {
    this.token = null;

    localStorage.removeItem(AUTH_KEY);
    sessionStorage.removeItem(AUTH_KEY);

    localStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(USER_KEY);

    this.surveyService.removeSmartAnalysisResults();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth-token.service.ts